<template>
    <v-container app :fluid="true" class="pt-0">
        <v-row>
            <v-col cols="2" class="pt-1">
                <v-menu
                    v-model="menuFromDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                        v-model="from_date"
                        label="Desde"
                        readonly
                        solo
                        dense
                        clearable
                        v-on="on"
                        @click:clear="handleClearFrom"
                        hide-details                                    
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="from_date" 
                        @input="menuFromDate = false" 
                        no-title
                        locale="es" 
                        @change="handleChangeFormDate">
                    </v-date-picker>
                </v-menu>
            </v-col>

            <v-col cols="2" class="pt-1">
                <v-menu
                    v-model="menuUntilDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                        v-model="until_date"
                        label="Hasta"
                        readonly
                        solo
                        dense
                        clearable
                        v-on="on"
                        @click:clear="handleClearUntil"
                        hide-details
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="until_date" @input="menuUntilDate = false" no-title @change="handleChangeUntilDate"></v-date-picker>
                </v-menu>
            </v-col>

            <v-col cols="2" class="pt-1">
                <v-btn dark color="green" 
                    @click="handleExportExcel">
                    XLS
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" class="pb-0">
                <v-card>
                    <template>
                        <v-row>
                            <v-col cols="12" class="pt-0 pb-0">
                                <v-data-table
                                    class="wost-table table-report-sale"
                                    :headers="headers"
                                    :items="credit_notes"
                                    item-key="id"
                                    height="60vh"
                                    fixed-header
                                    no-data-text=""
                                >
                                    <template v-slot:item.created_at="{item}">
                                        <span>
                                            {{ item.created_at | moment("DD/MM/YYYY") }}
                                        </span>
                                    </template>
                                    <template v-slot:item.hour="{item}">
                                        <span>
                                            {{ item.created_at | moment("hh:mm a") }}
                                        </span>
                                    </template>

                                    <template v-slot:item.document="{item}">
                                        <span v-if="item.order">
                                            {{ item.order.type_document }}
                                        </span>
                                    </template>

                                    <template v-slot:item.serie_ref="{item}">
                                        <span v-if="item.order">
                                            {{ item.order.serie }}
                                        </span>
                                    </template>

                                    <template v-slot:item.correlative_ref="{item}">
                                        <span v-if="item.order">
                                            {{ item.order.correlative }}
                                        </span>
                                    </template>

                                    <template v-slot:item.user_id="{item}">
                                        <span v-if="item.user">
                                            {{ item.user.first_name }} {{ item.user.last_name }}
                                        </span>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </template>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import XLSX from 'xlsx'
import Tools from '../../helpers/Tools';
import { mapActions, mapMutations, mapState } from 'vuex'
import ApiReports from '../../apis/Reports'

export default {
    name: 'CreditNotes',
    data () {
        return {
            headers: [
                { text: 'Fecha', value: 'created_at', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Hora', value: 'hour', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Serie', value: 'serie', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Nro', value: 'correlative', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Motivo', value: 'reason', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Doc. Referencia', value: 'document', align: 'left', sortable: false, class: 'header-table' },
                { text: 'Serie Ref.', value: 'serie_ref', align: 'left', sortable: false, class: 'header-table' },
                { text: 'Nro. Ref.', value: 'correlative_ref', align: 'left', sortable: false, class: 'header-table' },
                { text: 'Creado Por', value: 'user_id', align: 'left', sortable: false, class: 'header-table' },                
                { text: '', value: 'action', class: 'header-table-expand', align: 'end', sortable: false }
            ],
            credit_notes: [],
            menuFromDate: false,
            from_date: null,
            menuUntilDate: false,
            until_date: null,
        }
    },
    methods: {
        getCreditNotes(){
            let params = {
                from: this.from_date,
                until: this.until_date,
                customer_id: this.customer_id,
                final_deliveryman: this.final_deliveryman,
                type_document: this.type_document
            }
            ApiReports.getCreditNotes(params)
                .then(({data}) => {
                    this.credit_notes = data;
                })
        },
        handleClearFrom(){
            this.from_date = null
            this.getCreditNotes()
        },
        handleClearUntil(){
            this.until_date = null
            this.getCreditNotes()
        },
        handleChangeFormDate(){
            this.getCreditNotes()
        },
        handleChangeUntilDate(){
            this.getCreditNotes()
        },
        handleExportExcel(){
            let data = XLSX.utils.json_to_sheet(
                this.prepareDataExport(this.credit_notes),
                {
                    header: [
                        'fecha',
                        'hora',
                        'serie',
                        'numero',
                        'motivo',
                        'doc_ref',
                        'serie_ref',
                        'numero_ref',
                        'creado_por'
                    ]
                }
            )
            data['A1'].v = 'Fecha'
            data['B1'].v = 'Hora'
            data['C1'].v = 'Serie'
            data['D1'].v = 'Nro'
            data['E1'].v = 'Motivo'
            data['F1'].v = 'Doc. Referencia'
            data['G1'].v = 'Serie Ref.'
            data['H1'].v = 'Nro. Ref.'
            data['I1'].v = 'Creado Por'
            const workbook = XLSX.utils.book_new()
            const filename = 'reporte-de-notas-de-credito'
            XLSX.utils.book_append_sheet(workbook, data, filename)
            XLSX.writeFile(workbook, `${filename}.xlsx`)
        },
        prepareDataExport(sales){
            let dataExport = []
            sales.forEach(element => {

                let user = '';
                if (element.user.first_name) {
                    user = user + element.user.first_name;
                }
                if (element.user.last_name) {
                    user = user + ' ' +element.user.last_name;
                }
                
                let itemData = {
                    fecha: this.$moment(element.created_at).format('DD/MM/YYYY'),
                    hora: this.$moment(element.created_at).format('HH:mm:ss a'),
                    serie: element.serie,
                    numero: element.correlative,
                    motivo: element.reason,
                    doc_ref: element.order.type_document,
                    serie_ref: element.order.serie,
                    numero_ref: element.order.correlative,
                    creado_por: user,
                }
                dataExport.push(itemData)
            })
            return dataExport
        },
    },
    created() {
        this.getCreditNotes();
    }
}
</script>

<style scoped>

</style>